<template>
    <div class="container" >
        <!-- <h2>DisplayLEDHostOnMap组件</h2>
        <button @click="getLEDHostList">获取雾灯信息</button> -->
        
        <vc-entity v-for="(pos ,index) in positions" :key="index" :position="pos.pos" 
            :billboard="billboard"
            :label="labelArr[index]" 
            :polyline="polylineArr[index]" 
            @mouseover="onEntityEvt($event,pos.gprsAddr)"
            @mouseout="onEntityEvt($event,pos.gprsAddr)"
            @click="onEntityEvt($event,pos.gprsAddr)"
        ></vc-entity>

       

        <!-- 通过以下entity实现多层扩散圆，改变count属性的数字即可 -->
        <vc-entity ref="entity3" v-for="(pos ,index) in positions" :key="index" :position="pos.pos" >
            <vc-graphics-ellipse
            ref="cylinder1"
            :semiMinorAxis="500.0"
            :semiMajorAxis="500.0"
            :material="{fabric: {type: 'VcCircleWave', uniforms: {count: 1 ,color:[255,255,0,255]}}}"
            ></vc-graphics-ellipse>
        </vc-entity>

        
        <!-- 添加多个label方式 -->
        <!-- <vc-collection-label>
            <vc-label 
                v-for="(pos, index) of positions"
                :position="pos.pos"
                :key="'label'+index"
                :text="pos.label"
                :pixelOffset="[20, -5]"
                showBackground
                :backgroundColor="'rgba(0,0,0,0.6)'"
                :font="'2em'"
                :horizontal-origin="1"
            ></vc-label>
        </vc-collection-label> -->
        <DisplayLabelOnLED v-show="isShowLedLabel"></DisplayLabelOnLED>
        <DisplayLEDSet></DisplayLEDSet>
        <ReviseLEDSet ref="reviseLEDSet"></ReviseLEDSet>
    </div>
</template>

<script>
 
import axios from 'axios'
import DisplayLabelOnLED from '../components/DisplayLabelOnLED.vue'
import DisplayLEDSet from '../components/DisplayLEDSet.vue'
// 修改雾灯设置 组件
import ReviseLEDSet from '../components/ReviseLEDSet.vue'
// import bd09_to_wgs84 from '..public/util/coordinateConvert'
export default {
    name:'DisplayLEDHostOnMap',
    components:{DisplayLabelOnLED,DisplayLEDSet,ReviseLEDSet},
    data(){
        return {
            isShowLedLabel:false,
            ledHostList:[],
            positions:[],
            billboard: {
                image: require('../assets/Led.png'),//'https://zouyaoji.top/vue-cesium/favicon.png',
                scale: 0.1,
                distanceDisplayCondition: [0, 100000],
            },
            labelArr:[],
            polylineArr:[],
            // polyline:{
            //     positions:[],//[new Cesium.Cartesian3.fromDegrees(112.96,28.19, 5),new Cesium.Cartesian3.fromDegrees(112.96,28.19, 500)],
            //     material:'rgba(0,0,0,0.6)'
            // }
            // options:[]
        }
    },
    computed:{

    },
    methods:{
        getLEDHostList(){
            axios.get('http://47.111.99.118:8089/system/HostList').then(
                response => {
                    console.log('请求成功了',response.data)
                    this.ledHostList = response.data.data;
                    this.$bus.emit('LEDHostListDatas',this.ledHostList);//去更新雾灯列表
                    this.$nextTick(function(){
                     

                        this.ledHostList.forEach((value)=>{
                            let coord = bd09_to_wgs84(value.lon ,value.lat);
                            this.positions.push({gprsAddr:value.gprsAddr,pos:{lng:coord.longitude ,lat:coord.latitude,height:500},label:value.name});
                            this.labelArr.push({
                                    text:value.name,
                                    horizontalOrigin:1,
                                    font:'10em',
                                    pixelOffset:[20, -5],
                                    showBackground:true,
                                    backgroundColor:'rgba(0,0,0,0.6)',
                                    // distanceDisplayCondition: [0, 100000],
                                });
                                this.polylineArr.push(  { 
                                                        positions: [    {lng: coord.longitude,lat: coord.latitude,height: 5}   ,  
                                                                        {lng: coord.longitude,lat: coord.latitude,height: 500}  ],
                                                        material:'rgba(255,0,0,1)',
                                                        distanceDisplayCondition: [0, 100000],
                                                    });
                        
                        })
                         
                    })     
                    
                },
                error => {
                    console.log('请求失败了',error.message)
                }
            )
        },
        onEntityEvt(e, gprsAddr) {
            // console.log('onEntityEvt = ',e,gprsAddr);
            if (e.type === 'onmouseover') {   
                if(this.$refs.reviseLEDSet.style.display == "block"){
                    this.isShowLedLabel = false ;
                    return ;
                } 
                this.isShowLedLabel = true ;
                this.ledHostList.forEach((value)=>{                   
                    if(value.gprsAddr == gprsAddr){
                        let data = [];
                        let position = {x:e.windowPosition.x , y:e.windowPosition.y};
                        data.push(value);
                        data.push(position);
                        this.$bus.emit('ledHostDataOnLabel',data);
                    }
                })
            } else if (e.type === 'onmouseout') {
                this.isShowLedLabel = false ;
            } else if (e.type === 'onclick'){
                this.isShowLedLabel = false ;
                this.onClickLED(gprsAddr);
                
            }
        },
        onClickLED(gprsAddr){
            // 给 ReviseLEDSet (修改雾灯设置) 组件 发送信号，使呈现当前雾灯信息
            this.$bus.emit('currentLEDSet',gprsAddr);
        }
    },
    mounted(){
        this.$bus.on('getLEDHostList',this.getLEDHostList);    
    }, 
    beforeUnmount() {
        this.$bus.all.clear();
    }
}
</script>

<style scoped>
.container{
    position: absolute;
    /* width: 200px;
    height: 60px; */
    top: 5%;
    left: 5%;
    z-index: 100;
}
</style>